import httpClient from "../http/http-client";
import { IPostReductionOffset, IReductionOffset } from './reduction-offset.model';

export default class ReductionOffsetService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(queryParam?: string): Promise<IReductionOffset[]> {
    return this.http.get(`reduction-offset${queryParam ? queryParam : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getAllWithPagination(reportPeriodId: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IReductionOffset[] }> {
    return this.http.get(`reduction-offset?reportPeriodId=${reportPeriodId}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getOne(reductionOffsetId: string): Promise<IReductionOffset> {
    return this.http.get(`reduction-offset/${reductionOffsetId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async create(action: IPostReductionOffset): Promise<IPostReductionOffset> {
    return this.http.post(`reduction-offset`, action)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  // Multipart variants (REC pattern): certificate files + a JSON payload field.
  async createWithFile(form: FormData): Promise<IReductionOffset> {
    return this.http.post(`reduction-offset`, form)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async updateWithFile(reductionOffsetId: string, form: FormData): Promise<IReductionOffset> {
    return this.http.patch(`reduction-offset/${reductionOffsetId}`, form)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async remove(reductionOffsetId: string,): Promise<any> {
    return this.http.delete(`reduction-offset/${reductionOffsetId}` )
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async edit(reductionOffsetId: string, values: IPostReductionOffset): Promise<IPostReductionOffset> {
    return this.http.patch(`reduction-offset/${reductionOffsetId}`, values)
      .then(response => {
        return response.data  
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }
}